export default {
  'menu.workbench': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.announcements': 'お知らせ',
  'menu.policies': '制度',
  'menu.supplies': '備品',
  'menu.supplies.workbench': 'ワークベンチ',
  'menu.supplies.inventory': '在庫センター',
  'menu.supplies.receive': '受取管理',
  'menu.supplies.purchase': '調達管理',
  'menu.supplies.check': '棚卸管理',
  'menu.supplies.rule': 'ルールセンター',
  'menu.supplies.statistics': '統計分析',
  'menu.supplies.workflow': '承認センター',
  'menu.meetings': '会議',
  'menu.meetings.calendar': 'マイミーティング',
  'menu.meetings.bookings': '予約一覧',
  'menu.meetings.rooms': '会議室一覧',
  'menu.meetings.minutes': '議事録',
  'menu.meetings.reports': '利用率レポート',
  'menu.meetings.dashboard': 'ワークベンチ',
  'menu.meetings.settings': '設定',
  'menu.meetings.settings.booking': '予約ルール設定',
  'menu.meetings.settings.facilities': '会議室設定',
  'menu.meetings.settings.locations': '位置とフロア',
  'menu.meetingRoomDashboard': 'ワークベンチ',
  'menu.meetingRoomRooms': '会議室一覧',
  'menu.meetingRoomBookings': '予約一覧',
  'menu.meetingRoomCalendar': 'マイミーティング',
  'menu.meetingRoomMinutes': '議事録',
  'menu.meetingRoomUtilizationReport': '利用率レポート',
  'menu.meetingRoomSettings': '設定',
  'menu.meetingRoomBookingConfig': '予約ルール設定',
  'menu.meetingRoomFacilityTags': '会議室設定',
  'menu.meetingRoomLocationConfig': '位置とフロア',
  'menu.meetingRoomFloorPlan': 'フロアマップ',
  'menu.greenPlants': '緑化',
  'menu.greenplant': '植物管理',
  'menu.greenplant.dashboard': '植物ワークベンチ',
  'menu.greenplant.assets': '植物台帳',
  'menu.greenplant.spacePoints': '配置ポイント',
  'menu.greenplant.tasks': 'メンテナンス',
  'menu.greenplant.issues': '問題対応',
  'menu.greenplant.insights': '運用インサイト',
  'menu.greenplant.settings': '設定センター',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.settings': 'システム設定',
  'menu.settings.modelSettings': 'モデル設定',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
};
